/**
 * 画面に戻ってきたときの描き直し（S-00009 の確かめ、2026-10-11 射場さん）。
 *   iPhone の Safari で、画面を開いたまま放置して（ほかのアプリに移る・ロック）戻ると、上の帯（☰）も本文も真っ白で、
 *   固定した下のボタン列（.ph-fixbar＝position:fixed で別の層）だけ描かれる。少しスクロールすると描かれる＝戻ったときに本文の描き直しが走っていない。
 *   → 戻ってきた合図（visibilitychange で visible・pageshow で persisted＝戻る・進むのキャッシュから・window の focus）で、
 *     枠（.app）に data-repaint を2フレームだけ付けて外す。CSS は `.app[data-repaint]{opacity:.999}`＝枠ごと塗り直させる。
 *   opacity は位置・大きさ・文字を変えず、fixed の基準も変えない（transform・will-change だと下のボタン列が本文の末尾へ飛ぶので使わない）。
 *   続けて来た合図（visible と focus は同時に来る）は1回にまとめ、画面の大きさ（下のバー・dvh）が落ち着く頃（250ms 後）にもう1回。
 *   本物の放置は e2e で起こせない（合図を起こして枠と題が見えることだけ確かめる。e2e/safari-return.spec.ts）。最終の確かめは iPhone で
 */
export const REPAINT_AGAIN_MS = 250;

export function repaintOnReturn(el: HTMLElement): () => void {
  let raf = 0;
  let timer = 0;
  const kick = () => {
    cancelAnimationFrame(raf);
    el.dataset.repaint = "1";
    void el.offsetHeight; // このフレームで当てる
    raf = requestAnimationFrame(() => {
      raf = requestAnimationFrame(() => {
        delete el.dataset.repaint;
      });
    });
  };
  const onReturn = () => {
    if (document.visibilityState === "hidden") return;
    if (el.dataset.repaint == null) kick();
    window.clearTimeout(timer);
    timer = window.setTimeout(kick, REPAINT_AGAIN_MS);
  };
  const onVisible = () => {
    if (document.visibilityState === "visible") onReturn();
  };
  const onShow = (e: PageTransitionEvent) => {
    if (e.persisted) onReturn();
  };
  document.addEventListener("visibilitychange", onVisible);
  window.addEventListener("pageshow", onShow);
  window.addEventListener("focus", onReturn);
  return () => {
    document.removeEventListener("visibilitychange", onVisible);
    window.removeEventListener("pageshow", onShow);
    window.removeEventListener("focus", onReturn);
    cancelAnimationFrame(raf);
    window.clearTimeout(timer);
    delete el.dataset.repaint;
  };
}
